import { render, staticRenderFns } from "./LoadingProcess.vue?vue&type=template&id=4a24412a"
import script from "./LoadingProcess.vue?vue&type=script&lang=js"
export * from "./LoadingProcess.vue?vue&type=script&lang=js"
import style0 from "./LoadingProcess.vue?vue&type=style&index=0&id=4a24412a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports